<template>
  <div class="card">
    <div v-if="header" class="card-header">
      Signature Preview
    </div>
    <div class="card-body">
      <small v-if="behalf" class="text-muted mb-3 d-inline-block">
        {{ behalf }}
      </small>
      <div class="signature">
        {{ signature.name }}
      </div>
    </div>
    <div class="card-footer text-muted bg-white border-top-0 pt-0">
      <small>
        {{ signature.name }}<br v-if="signature.name" />
        {{ signature.email }}<br v-if="signature.email" />
        {{ signature.job_title }}<br v-if="signature.job_title" />
        {{ signature.signed_at | localDateTime }}
      </small>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    header: {
      type: Boolean,
      default: false,
    },
    signature: {
      type: Object,
      default: () => {},
    },
  },

  computed: {
    behalf() {
      if (!this.signature.behalfable) {
        return null;
      }
      return `Signed by, for and on behalf of ${this.signature.behalfable.name}`;
    },
  },
};
</script>
